export default __webpack_public_path__ + "static/media/_DSC0564.b64c9af3.JPG";